import { Divider, Typography } from "@mui/material";
import {
  NoteEditWrapper,
  RiskSelectController,
  SubSectionTitle,
  useSpContext,
} from "components/summary/success-plan";
import styles from "./SuccessPlanWorkflow.module.scss";
import { UseFormReturn } from "react-hook-form";

type WorkloadAssessmentEditProps = {
  title: string;
  dropDownLbl: string;
  dropDownField: string;
  noteLbl: string;
  noteField: string;
  form: UseFormReturn<any>;
  histories: any[];
  historyField: string;
  required: boolean;
  addDivider?: boolean;
};

const WorkloadAssessmentEdit = ({
  title,
  dropDownLbl,
  dropDownField,
  noteLbl,
  noteField,
  form,
  histories,
  historyField,
  required,
  addDivider = true,
}: WorkloadAssessmentEditProps) => {
  const { control, setValue } = form;
  const { riskItems } = useSpContext();
  const noteHistories = histories.filter((history: any) => history.fieldName === historyField);

  return (
    <>
      <div className={styles["grid-column-span-2"]}>
        <SubSectionTitle title={title} />
      </div>
      <div className={styles["form-field-wrapper"]}>
        <Typography className={styles["form-field-label"]}>{dropDownLbl}</Typography>
        {required && <Typography className={styles["form-field-star"]}>*</Typography>}
      </div>
      <RiskSelectController
        control={control}
        name={dropDownField}
        riskItems={riskItems}
        required={required}
      />
      <div className={styles["grid-column-span-2"]}>
        <NoteEditWrapper
          label={noteLbl}
          required={required}
          histories={noteHistories}
          name={noteField}
          control={control}
          setValue={setValue}
        />
      </div>
      {addDivider && (
        <div className={styles["grid-column-span-2"]}>
          <Divider />
        </div>
      )}
    </>
  );
};

export default WorkloadAssessmentEdit;
